// function that finds a node in a tree given a condition
export function findNode({ tree, condition, childrenKey }) {
  if (!Array.isArray(tree)) {
    console.error('tree must be an array');
    return undefined;
  }
  if (!condition) {
    console.error('condition must be a function');
    return undefined;
  }
  if (!childrenKey) {
    console.error('childrenKey must be a string');
    return undefined;
  }

  let foundNode = undefined;
  const findNodeRecursively = (node) => {
    if (!node) return;
    if (condition(node)) {
      foundNode = node;
      return;
    }
    if (node[childrenKey]) {
      node[childrenKey].forEach(findNodeRecursively);
    }
  };
  tree.forEach(findNodeRecursively);
  return foundNode;
}
